import React from 'react';
import { useAppSelector, configSelectors, } from '@pomofocus/shared-client';
import { IconSets } from '../../common/IconSets';
import { SectionWrapper, FormBlock, FormHeader, FormHeaderText, FormBody, FormLabelForm, Label, ConfigFormNumber, FlexWrapper, Switch, } from './common';
export const TimerConfig = ({ pomodoroMin, shortBreakMin, longBreakMin, onChangePomodoroMin, onChangeShortBreakMin, onChangeLongBreakMin, handleSwitchAutoStart, handleSwitchAutoStartPomodoro, handleChangeLongBreakInterval, }) => {
    const configObj = useAppSelector(configSelectors.selectConfigObj);
    const handleChangeStageSeconds = (stage, newMinutes) => {
        const minutes = parseFloat(newMinutes) || 0;
        const newMinutesUnder999 = minutes > 999 ? 999 : minutes;
        switch (stage) {
            case 0:
                onChangePomodoroMin(newMinutesUnder999);
                break;
            case 1:
                onChangeShortBreakMin(newMinutesUnder999);
                break;
            case 2:
                onChangeLongBreakMin(newMinutesUnder999);
                break;
            default:
        }
    };
    return (React.createElement(SectionWrapper, { subHeader: "Timer", SubHeaderIcon: React.createElement(IconSets, { name: "Clock" }) },
        React.createElement(FormBlock, null,
            React.createElement(FormHeader, null,
                React.createElement(FormHeaderText, null, "Time (minutes)")),
            React.createElement(FormBody, null,
                React.createElement(FormLabelForm, null,
                    React.createElement(Label, null, "Pomodoro"),
                    React.createElement(ConfigFormNumber, { onChange: (e) => handleChangeStageSeconds(0, e.target.value), value: pomodoroMin })),
                React.createElement(FormLabelForm, null,
                    React.createElement(Label, null, "Short Break"),
                    React.createElement(ConfigFormNumber, { onChange: (e) => handleChangeStageSeconds(1, e.target.value), value: shortBreakMin })),
                React.createElement(FormLabelForm, null,
                    React.createElement(Label, null, "Long Break"),
                    React.createElement(ConfigFormNumber, { onChange: (e) => handleChangeStageSeconds(2, e.target.value), value: longBreakMin })))),
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null, "Auto Start Breaks")),
                React.createElement(Switch, { enabled: configObj.autoStartEnabled, onClick: handleSwitchAutoStart }))),
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null, "Auto Start Pomodoros")),
                React.createElement(Switch, { enabled: configObj.autoStartPomodoroEnabled, onClick: handleSwitchAutoStartPomodoro }))),
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null, "Long Break interval")),
                React.createElement(ConfigFormNumber, { min: "1", onChange: (e) => handleChangeLongBreakInterval(parseInt(e.target.value) || 1), value: configObj.longBreakInterval, width: 70 })))));
};
